
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { ChooseTreatmentContext } from '../FreeDosageLayoutV2'
import SearchIcon from "../../../../icons/Search-White.svg"
import { translate } from '../../../../utils/translator'

type Props = {
    className?: string
}

const ProductSearch:React.FC<Props> = ({className}) => {

    const { language } = useParams();
    const chooseTreatmentContext = useContext(ChooseTreatmentContext);
    const searchTerm = chooseTreatmentContext?.searchTerm ?? "";

    const handleSearchChange = (value: string) => {
        chooseTreatmentContext?.setSearchTerm(value);
    };

    return (
        // Product Search Container 
        <div id='product-search-container' className={`w-full min-w-0 overflow-hidden shadow-sm rounded-md items-center flex justify-between gap-4 py-3 px-4 bg-white ${className}`}>
            
            {/* Product Search Input  */}
            <input id='product-search' className='text-[16px] h-full w-full min-w-0 flex-1 border-none rounded-md focus:outline-none'
                type="text"
                value={searchTerm}
                onChange={(e) => handleSearchChange(e.target.value)}
                placeholder={translate(language, 'choose_treatment', 'default/search_placeholder')}
            />
            
            {/* Product Search Icon  */}
            <img src={SearchIcon} id='product-search-icon' className='bg-primary-button-gradient rounded-md flex justify-center p-2 text-xl text-white items-center' />
        </div>
    )
}

export default ProductSearch
